import type { ReactElement } from "react";

import { ICONS } from "../../design-system/icons";
import type { IconName } from "../../design-system/icons";
import styles from "./Icon.module.css";

/** The three steps of the type scale a glyph may borrow. */
export type IconSize = "sm" | "md" | "lg";

export interface IconProps {
  readonly name: IconName;
  readonly size?: IconSize | undefined;
}

/**
 * The only way the application renders a glyph.
 *
 * There is no `color` prop, and there will not be one: the SVG paints with
 * `currentColor`, so the colour is whatever the surrounding text already
 * decided (F-UIX-006). A glyph carries no accessible name either — a button
 * whose only label is an icon declares `aria-label` itself (F-UIX-007).
 */
export function Icon({ name, size = "md" }: IconProps): ReactElement {
  const Glyph = ICONS[name];
  return <Glyph className={styles[size]} />;
}
